<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Configuration.Member'
}
</script>

<style scoped>

</style>
